import React from 'react';
import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem;
  text-align: center;
  color: ${lightGrey2Color};
  font-size: 1rem;
  line-height: 1rem;
  font-weight: 500;
  cursor: pointer;

  :hover {
    color: ${lightGrey2Color.darken()};
  }
  :active {
    color: black;
  }
`;

export default ({ onClick, ...rest }) => (
  <Container onClick={onClick} {...rest}>
    X
  </Container>
);
